/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.credits.init());

App.credits = {
  init() {
    return App.subscribe("account.credits.updated", App.credits.updated);
  },

  // evt.detail:  { credits: int }
  updated(evt) {
    const {
      credits
    } = evt.detail;
    const credits_short = App.utils.kify(credits);
    const credits_long  = App.utils.dumb_pluralize(App.utils.number_with_delimiter(credits), "Credit");
    $(".js-credits-short").html(credits_short);
    $(".js-credits-long").html(credits_long);

    const $display = $(".js-credits-display");
    if ($display.length) {
      const threshold = parseInt($display.data("credits-threshold"), 10) || 0;
      const isLow = threshold > 0 && credits < threshold;
      $(".js-credits-compact").toggleClass("hidden", isLow);
      $(".js-credits-expanded").toggleClass("hidden", !isLow);
      $(".js-credits-refill").toggleClass("hidden", !isLow);
    }
  }
};
